import React from 'react';
import {
  LabelConformanceBadge,
  LabelParticipationBadge,
} from 'components/Labels';
import styles from './styles.module.scss';
import {ContentTable, ContentTableText} from 'components/Contents';
import {Container} from 'reactstrap';
import {CONFORMANCE_STATUS} from 'configs';

function CBParticipationStatus(props) {
  const {isLoading, data} = props || {};
  const {accreditation_bodies = []} = data;

  return (
    <section className={styles['participation']}>
      <h3 className={styles['section__title']}>CB Participation Status</h3>
      <p>
        Indicates alignment with IAF standards based on documented participation
        and adherence to mandatory requirements, confirming commitment to
        quality and safety standards.
      </p>

      <Container className={styles['table-container']}>
        <ContentTable
          v2
          hover={false}
          className="mb-0"
          minHeight="364px"
          responsive={false}
          isFetching={isLoading}
          head={[
            'Accreditation Body',
            {
              label: 'Participation',
              infoText: {
                prepend: true,
                text: 'refers to account activity in IAF',
              },
            },
            {
              label: 'Conformance',
              infoText: {
                prepend: true,
                text: 'refers to the compliance of data with IAF',
              },
            },
          ]}
        >
          {accreditation_bodies.map((item, index) => {
            const {
              accreditation_bodies_id,
              accreditation_bodies_name,
              certification_bodies_participation,
              certification_bodies_conformance,
            } = item;

            return (
              <tr key={`participation-${index}`}>
                <td>
                  <ContentTableText
                    to={`/accreditation-body/${accreditation_bodies_id}`}
                  >
                    {accreditation_bodies_name}
                  </ContentTableText>
                </td>
                <td>
                  <LabelParticipationBadge
                    status={certification_bodies_participation}
                  />
                </td>
                <td>
                  {certification_bodies_conformance !==
                    CONFORMANCE_STATUS['exclusion conformance'] && (
                    <LabelConformanceBadge
                      status={certification_bodies_conformance}
                    />
                  )}
                </td>
              </tr>
            );
          })}
        </ContentTable>
      </Container>
    </section>
  );
}

export default CBParticipationStatus;
